if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	$('.image-slides').on('init', function(event, slick){
        var dots = $( '.slick-dots li' );
        
        dots.each( function( k, v){
            $(this).find( 'button' ).addClass( 'heading'+ k );
        });
   
        var items = slick.$slides;

        items.each( function( k, v){
            var text = $(this).find( 'figcaption' ).text();
            var link = $(this).attr("data-link");
            $( '.heading' + k ).text(text);
            $( '.heading' + k ).attr('onclick', "window.location.href='" + link + "'")
            $( '.heading' + k ).attr('aria-label', "Click here and go to " + text);
        
        });

        dots.each(function(k) {
            $(this).hover(
                function(){
                    $('.image-slides').slick('slickGoTo',k);
                }
            );
        });
    });
        $('.slick-wrap').slick({
        dots: true,
        focusOnSelect: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
        });


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.quad-slides').slick({
        fade: true,
        dots: false,
        focusOnSelect: true,
        accessibility: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        });


    $('.steps__step:not(.past)').click(function(e){
        e.preventDefault();
    });

    $('.gallery-block-two__list')
    .on('afterChange init', function(event, slick, direction){
        console.log('afterChange/init', event, slick, slick.$slides);
        // remove all prev/next
        slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
        for (var i = 0; i < slick.$slides.length; i++)
        {
            var $slide = $(slick.$slides[i]);
            if ($slide.hasClass('slick-current')) {
                $slide.prev().addClass('prevdiv');
                $slide.next().addClass('nextdiv');
                break;
            }
        }
      }
    )
    .on('beforeChange', function(event, slick) {
        // optional, but cleaner maybe
        // remove all prev/next
        slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
    })
    .slick({
      centerMode: true,
      centerPadding: '27%',
      focusOnSelect: true,
      slidesToShow: 1,
      arrows: false,
    });

    //** Label  input phone signup */

        let labelPhone = document.getElementById('email-signup_phone');
        let caption =  ` <p class="form-caption">
            By entering your phone number, you are agreeing to receive text messages from Delamar. Message & data rates may apply. Message frequency may vary. Reply HELP for more information. You can reply STOP or UNSUBSCRIBE to opt-out. See our Privacy Policy for additional details.
        </p>`;
        
        if(labelPhone){
            labelPhone.insertAdjacentHTML('afterend', caption);
    
        }
    //** END  */

})();

if(document.getElementById("fsCountdown")){
	const fsCountdown = new Date(document.getElementById('fsCountdown').getAttribute('data-time'));
		//countdown
		let fsDays = 0;
		let fsHours = 0;
		let fsMinutes = 0;
		let fsSeconds = 0;
		tick();
    let fsTimer = setInterval(tick.bind(this), 1000);
 
	function updateRemaining(fsDistance) {
		fsDays = Math.floor(fsDistance / (1000 * 60 * 60 * 24));
		fsHours = Math.floor((fsDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		fsMinutes = Math.floor((fsDistance % (1000 * 60 * 60)) / (1000 * 60));
		fsSeconds = Math.floor((fsDistance % (1000 * 60)) / 1000);

		document.getElementById('fsDays').innerHTML = fsDays;
		document.getElementById('fsHours').innerHTML = fsHours;
		document.getElementById('fsMinutes').innerHTML = fsMinutes;
		document.getElementById('fsSeconds').innerHTML = fsSeconds;
	}
	function tick() {
		const currentTime = new Date();
		const fsDistance = Math.max(fsCountdown - currentTime, 0);
		updateRemaining(fsDistance);
		
		if (fsDistance === 0) {
			clearInterval(fsTimer);
		}
	};
}

/* Add checkbox in footer form
********************************** */

let formLastField = document.querySelectorAll('.fields-wrap .field.input')
console.log("🚀 ~ formLastField:", formLastField)
console.log("🚀 ~ formLastField:", formLastField[formLastField.length - 1])
let formLastFieldPosition = document.querySelector('.fields-wrap .gdpr-wrap');

/* create a new div and its class */
const fieldDiv = document.createElement('div');
fieldDiv.className = 'field gdpr sms';

/* Create a label and its content and class */
const label = document.createElement('label');
label.setAttribute('for', 'email-signup_accept-sms-messages');
label.className = 'form-label';
label.textContent = 'I would like to receive order updates and promotional SMS messages. Opt-out anytime.';

/* Create a input and its attibutes */
const input = document.createElement('input');
input.setAttribute('type', 'checkbox');
input.setAttribute('id', 'email-signup_accept-sms-messages');
input.setAttribute('name', 'accept-sms-messages');
input.setAttribute('value', 'y');

/* Add input and label to div */
fieldDiv.appendChild(input);
fieldDiv.appendChild(label);

// Add content to DOM
// formLastField[formLastField.length - 1].insertAdjacentElement('afterend', fieldDiv);
formLastFieldPosition.appendChild(fieldDiv);



/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('.nav-desktop');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .social-media a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.nav-desktop');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});
